import React, { useEffect } from 'react';
import { Phone } from 'lucide-react';
import { BRAND } from './brand';
import './mobile-call-bar.css';

// Sticky "Call now" bar for phones, plus click-to-call tracking for every tel: link on
// the public site (sent to Google Analytics as `click_to_call`, usable as an Ads conversion).
const hidden = () => {
  const p = window.location.pathname;
  return p === '/crm' || p.startsWith('/crm/') || p.startsWith('/admin');
};

const MobileCallBar = () => {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="tel:"], a[href*="wa.me/"], a[href*="api.whatsapp.com"], a[href^="whatsapp:"]');
      if (!a || hidden() || typeof window.gtag !== 'function') return;
      const href = a.getAttribute('href') || '';
      const isCall = href.startsWith('tel:');
      window.gtag('event', isCall ? 'click_to_call' : 'whatsapp_click', {
        ...(isCall ? { phone_number: href.replace('tel:', '') } : {}),
        page_path: window.location.pathname,
      });
      // Google Ads conversion: "Website call or WhatsApp click"
      window.gtag('event', 'conversion', { send_to: 'AW-17680721341/7D--CLjGv7AdEL3L6e5B' });
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  if (typeof window !== 'undefined' && hidden()) return null;
  return (
    <a className="vk-callbar" href={BRAND.phoneLink} aria-label={`Call VK Tours on ${BRAND.phone}`}>
      <Phone size={20} aria-hidden="true" />
      <span>Call now · {BRAND.phone}</span>
    </a>
  );
};

export default MobileCallBar;
